// modifer: styles/jss/nextjs-material-kit-pro/pages/componentsSections/javascriptStyles
import { title, grayColor, description } from 'styles/jss/original/base';

import modalStyle from 'styles/jss/nextjs-material-kit-pro/modalStyle.js';

const styles = (theme) => ({
  ...modalStyle(theme),
  modal: {
    '@media (max-width: 640px)': {
      margin: '24px',
      marginTop: '24px !important'
    }
  },
  buttonFloating: {
    position: 'fixed',
    zIndex: '1002',
    bottom: '2rem',
    right: '2rem'
  },
  modalTitle: {
    fontWeight: '600',
    textAlign: 'center',
    marginLeft: '50px',
    color: grayColor[1]
  },
  title: {
    ...title,
    marginTop: '20px',
    minHeight: '32px',
    textDecoration: 'none'
  },
  description: {
    ...description,
    textAlign: 'center',
    margin: '0'
  },
  closeButton: {
    '&:hover,&:focus': {
      color: 'inherit',
      background: 'transparent'
    }
  }
});

export default styles;
